import { CashOptions } from '@makemydeal/dr-platform-types';

const CASH_STRIPPED_MAP: Record<string, string> = {
    Cash: 'None',
    CashRebate: 'Rebate',
    CashRebateTrade: 'RebateTrade',
    CashTrade: 'Trade',
    CashTradeRebate: 'TradeRebate',
    RebateCash: 'Rebate',
    RebateCashTrade: 'RebateTrade',
    RebateTradeCash: 'RebateTrade',
    TradeCash: 'Trade',
    TradeCashRebate: 'TradeRebate',
    TradeRebateCash: 'TradeRebate'
};

const CASH_PREPENDED_MAP: Record<string, string> = {
    None: 'Cash',
    Rebate: 'CashRebate',
    RebateTrade: 'CashRebateTrade',
    Trade: 'CashTrade',
    TradeRebate: 'CashTradeRebate'
};

export const stripCashFromEquityAllocationMethod = (method: string): string => {
    return CASH_STRIPPED_MAP[method] ?? method;
};

export const prependCashToEquityAllocationMethod = (method: string): string => {
    return CASH_PREPENDED_MAP[method] ?? method;
};

export const isCashEquityAllocationMethod = (method: string): boolean => {
    return method in CASH_STRIPPED_MAP;
};

export const APPLY_METHOD_DUE_IN_ADVANCE = 'DueInAdvance';

export const translateApplyMethodsToEquityAllocationMethod = (
    cashApplyMethod?: string,
    tradeApplyMethod?: string,
    rebateApplyMethod?: string
): string | undefined => {
    if (!cashApplyMethod || !tradeApplyMethod || !rebateApplyMethod) return undefined;

    const cashInOrder =
        cashApplyMethod === CashOptions.OutOfPocket ||
        cashApplyMethod === CashOptions.AddCashOffsetToPrice ||
        cashApplyMethod === APPLY_METHOD_DUE_IN_ADVANCE;
    const tradeInOrder = tradeApplyMethod === APPLY_METHOD_DUE_IN_ADVANCE;
    const rebateInOrder = rebateApplyMethod === APPLY_METHOD_DUE_IN_ADVANCE;

    const order = [cashInOrder && 'Cash', tradeInOrder && 'Trade', rebateInOrder && 'Rebate'].filter(Boolean).join('');

    return order || 'None';
};
